const defaultCell = {
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  overflow: 'hidden',
}

export {
  defaultCell,
};
